import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download_production/6abb4c655347340014a037e3_1790823327312_31ffb909/creatorvillage/node_modules/next/dist/client/app-dir/link.js");
